export default __webpack_public_path__ + "static/media/digital_marketing.692a1193.jpg";